<ccwb-spinner class="spinner-dimensions" [hidden]="(scriptLoaded$ | async) === true" theme="dark" />
<cc-script-loader [scriptParams]="scriptParams" (scriptLoadedEvent)="scriptLoadedHandler($event)">
  <div [hidden]="(scriptLoaded$ | async) === false">
    @if ({ vehicleId: vehicleId$ | async, onlineCode: directOnlineCode$ | async }; as data) {
      <!-- ℹ️: tag name must be same as COMPONENT_NAME in component.ts file! -->
      @if (isFullFunctionalButton === true) {
        <eqpodc-save-button
          class="eqpodc-save-button"
          [attr.vehicle-id]="data.vehicleId"
          [attr.vehicle-online-code]="data.onlineCode"
          [attr.save-label]="(!isMobile || showLabelOnMobile ? saveLabel : '') | translate: returnTranslationOrKey"
          [attr.saved-label]="(!isMobile || showLabelOnMobile ? savedLabel : '') | translate: returnTranslationOrKey"
          [attr.size]="size"
          [attr.color]="saveColor"
          [attr.color-saved]="savedColor"
          [attr.update-touchpoint-uuid]="vehicleWishlistUuid$ | async"
          [is-disabled]="isDisabled || null"
          [attr.full-width]="isFullWidth ? '' : null"
          (saved-error)="raiseErrorNotification($event)"
          (click)="onlineCodeCreator($event)"
          (saved)="onSaved($event)"
          (updated)="onUpdated($event)"
          (initialized)="onInitializated($event)"
          client-id="owcc"
          ui-type="button"
          icon="star"
          iconSaved="star"
          icon-size="12"
          save-only="true"
        />
      } @else {
        <eqpodc-save-button
          class="eqpodc-save-button"
          [attr.update-touchpoint-uuid]="vehicleWishlistUuid$ | async"
          [attr.vehicle-id]="data.vehicleId"
          [attr.vehicle-online-code]="data.onlineCode"
          (saved-error)="raiseErrorNotification($event)"
          (saved)="onSaved($event)"
          (updated)="onUpdated($event)"
          (initialized)="onInitializated($event)"
          client-id="owcc"
          save-only="true"
        />
      }
    }
  </div>
</cc-script-loader>
